const indexItems = [
  { id: 1, title: '明星塌房全纪录', count: '128篇', desc: '从顶流到翻车，完整事件追踪', icon: 'ri-user-unfollow-line' },
  { id: 2, title: '网红翻车现场', count: '96篇', desc: '带货翻车、人设崩塌合集', icon: 'ri-alert-line' },
  { id: 3, title: '综艺名场面', count: '85篇', desc: '那些被镜头记录下的尴尬瞬间', icon: 'ri-emotion-laugh-line' },
  { id: 4, title: '直播圈大事件', count: '73篇', desc: '头部主播恩怨情仇全记录', icon: 'ri-live-line' },
  { id: 5, title: '体育圈爆料', count: '62篇', desc: '赛场内外的劲爆故事', icon: 'ri-basketball-line' },
  { id: 6, title: '娱乐圈内幕', count: '58篇', desc: '圈内人士匿名深度爆料', icon: 'ri-movie-line' },
  { id: 7, title: '年度吃瓜盘点', count: '45篇', desc: '按年份整理的热门事件回顾', icon: 'ri-calendar-check-line' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            专题合集
          </h2>
          <p className="text-sm text-foreground-500 mt-2">按主题分类整理的吃瓜内容，快速找到你感兴趣的</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
          {indexItems.map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              className="group flex items-start gap-3 p-4 bg-background-50 border border-background-200 rounded-xl transition-all duration-200 hover:border-accent-300 hover:bg-accent-50/30 cursor-pointer no-underline"
            >
              <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0 group-hover:bg-accent-200 transition-colors">
                <i className={`${item.icon} text-accent-600 text-lg`}></i>
              </div>
              <div className="min-w-0">
                <h3 className="text-sm font-heading font-bold text-foreground-950 group-hover:text-accent-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-1 line-clamp-1">{item.desc}</p>
                <span className="inline-block mt-2 text-[10px] text-accent-600 bg-accent-100 px-2 py-0.5 rounded-full">
                  {item.count}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}